import { render, staticRenderFns } from "./ClassAssignment.vue?vue&type=template&id=fdf3ec22&scoped=true&"
import script from "./ClassAssignment.vue?vue&type=script&lang=js&"
export * from "./ClassAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf3ec22",
  null
  
)

export default component.exports